import { render } from "./priorityType.vue?vue&type=template&id=2bf685ea&scoped=true"
import script from "./priorityType.vue?vue&type=script&lang=js"
export * from "./priorityType.vue?vue&type=script&lang=js"

import "./priorityType.vue?vue&type=style&index=0&id=2bf685ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf685ea"]])

export default __exports__